import { render, staticRenderFns } from "./xlsxPreview.vue?vue&type=template&id=6de95d11"
import script from "./xlsxPreview.vue?vue&type=script&lang=js"
export * from "./xlsxPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports